export default Object.freeze({
    EN: 'en',
    SR: 'sr',
    BIH: 'bih',
    RU: 'ru',
})
